import React, { useContext, useEffect, useRef, useState } from 'react';
import { ColumnProps } from 'antd/lib/table';
import { SearchOutlined, UndoOutlined, FileExcelFilled } from '@ant-design/icons';
import { Row, Col, Table,Input, Button, Card, Form,message, Select } from 'antd';
import { Link } from 'react-router-dom';
import {Excel} from 'antd-table-saveas-excel'
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import { VillageTransportCostService } from '@gtpl/shared-services/masters';


const VillageTransportGrid = () => {

const searchInput = useRef(null);
const {Option} = Select
const [page, setPage] = React.useState(1);
const service = new VillageTransportCostService()
const [data,setData] = useState<any[]>([])
const [searchText, setSearchText] = useState('');
const [searchedColumn, setSearchedColumn] = useState('');

useEffect(()=>{
  getAllVillageTransporationCostData()
},[]);


const getAllVillageTransporationCostData=() =>{
  service.getAllVillageTransporationCostData().then(res=>{
    if(res.status){
      setData(res.data)
      message.success(res.internalMessage,1)
    }else{
      setData([])
      message.error(res.internalMessage,2)
    }
  })
  
}


const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
            : false,
        onFilterDropdownVisibleChange: visible => {
          if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
          text ? (
            searchedColumn === dataIndex ? (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ) : text
          )
            : null
    
      });

      
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const columnSkeltion:ColumnProps<any>[] =[
    {
        title: 'S No',
        key: 'sno',
        width: '70px',
        responsive: ['sm'],
        render: (text, object, index) => (page - 1) * 10 + (index + 1)
      },
      {
        title: 'Village Name',
        dataIndex: 'villageName',
        // responsive: ['lg'],
        sorter: (a, b) => a.villageName?.localeCompare(b.villageName),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('villageName'),
        render: (text: string) => text || '-'
    },
    {
        title: 'Transport In Rupees',
        dataIndex: 'transporttaionCost',
        // responsive: ['lg'],
        sorter: (a, b) => a.transporttaionCost?.localeCompare(b.transporttaionCost),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('transporttaionCost'),
        render: (text: string) => text || '-'
    },

  ];

  const exceldata = [
    { title: 'S No', dataIndex: 'sNo', render: (text, object, index) => { 
        if(index == data.length) { 
          return null;
        } else { 
          return index+1
        } 
      },
      width: 60, 
    },
    { title: 'Village NAME', dataIndex: 'villageName',width: 500,render:(text:any,record:any) => {return record.villageName ? record.villageName : '-'} },     
    { title: 'Transport Cost', dataIndex: 'transporttaionCost',width: 100,render:(text:any,record:any) => {return record.transporttaionCost ? record.transporttaionCost : '-'} },

  ]
  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet(' Village Transport cost Excel')
      .addColumns(exceldata)
      .addDataSource(data, { str2num: false })
      .saveAs('village transportation cost.xlsx');
  }

 
  return (
    <Card 
    title={<span style={{ color: 'white' }}>Village Transportation Cost</span>}
    style={{ textAlign: 'center' }} 
    headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    extra={
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Link to="/village-transport-cost">
          <Button className='panel_button'>Upload File</Button>
        </Link>
        <Button
          type="default"
          style={{ color: 'green' }}
          onClick={exportExcel}
          icon={<FileExcelFilled />}
        >
          Download Excel
        </Button>
      </div>
    }
  >
    <Table
      columns={columnSkeltion}
      dataSource={data}
      pagination={{
        onChange(current) {
          setPage(current);
        }
      }}
      onChange={onChange}
      bordered
    />
  </Card>
    
  )
}

export default VillageTransportGrid